module.exports = __webpack_public_path__ + "img/3.7d5d8ba1.jpg";